
import React, {useState} from 'react';
import Button from '@material-ui/core/Button';

import { FormContext } from 'core/FormProvider';
import { ContextWidget } from 'form/Contexed';
import FormGroup from 'form/FormGroup';
import { InputWidget, InputNumberWidget } from 'form/InputWidget';
import { AsyncSelectManyButtonWidget } from 'form/SelectManyButtonWidget';
import { YellowButton } from 'ui/Button';
import { Drawer } from 'ui/Drawer';
import DaDataGeocodeAutocomplete from "form/custom/DaDataGeocodeAutocomplete";


export function PointForm() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen)
  };

  const onAddressChange = (formContext, value) => {
    if (typeof value === 'string') {
      formContext.setValue('address', value)
    }
    else if (value?.address) {
      formContext.setValue('address', value.address)
    }
  }

  return (
    <FormContext.Consumer>
      {context => {
        const { item, setValue } = context;

        return (
          <FormGroup>
            <ContextWidget
              name={'name'}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Название',
                required: true,
                multiline: true
              }}
            />

            <ContextWidget
              name={'name_legal'}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Полное юридическое наименование',
                multiline: true
              }}
            />

            <div className={'mb-20'}>
              <DaDataGeocodeAutocomplete
                value={item.address}
                onChange={(value) => onAddressChange(context, value)}
                textFieldProps={{
                  label: 'Адрес'
                }}
              />
            </div>

            <ContextWidget
              name={'description'}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Примечание к адресу',
                multiline: true
              }}
            />

            <ContextWidget
              name={'contact'}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Контакты',
                multiline: true
              }}
            />

            <ContextWidget
              name={'distance'}
              WidgetComponent={InputNumberWidget}
              widgetProps={{
                label: 'Отстояние, км'
              }}
            />

            <div className={'mb-20'}>
              <Button
                onClick={() => toggleDrawer()}
                variant="outlined"
              >
                Доступные услуги {item.services ? item.services.length : '0'}
              </Button>
            </div>

            <Drawer
              open={isDrawerOpen}
              onClose={() => toggleDrawer()}
              width={'500px'}
            >
              <h2>Услуги на точке</h2>
              <AsyncSelectManyButtonWidget
                value={item.services}
                url={'catalog/service'}
                filter={{
                  type: 'TARIFF'
                }}
                onChange={(values) => setValue('services', values)}
                isOptionDisabled={(option) => !option.is_active }
              />

              <div className={'mt-20'}>
                <YellowButton
                  size={'large'}
                  onClick={(e) => toggleDrawer()}
                >
                  Применить
                </YellowButton>
              </div>
            </Drawer>

          </FormGroup>
        )
      }}
    </FormContext.Consumer>
  )
}
